import is from '@sindresorhus/is';
import { useCallback } from 'react';

import type { ProfileTaskInteractionAction } from '~/shared/tracking/job-architecture-tracking-events';

import { useMixpanelTracking } from '../../../tracking/mixpanel/use-mixpanel-tracking';
import { useJsaTrackingContext } from '../../hooks/analytics/use-jsa-tracking-context';
import type { ProfileTaskParentContext } from '../model/profile-task';

export const useTrackProfileTaskInteraction = (context: ProfileTaskParentContext) => {
    const { trackEvent } = useMixpanelTracking();
    const trackingContext = useJsaTrackingContext();
    const { architectureId, parentId, parentType, parentVersion } = context;
    const { tenantId, timestamp, userId } = trackingContext;

    return useCallback(
        (action: ProfileTaskInteractionAction): void => {
            if (!is.number(parentVersion)) {
                return;
            }

            trackEvent({
                name: 'profile-task-interaction',
                payload: {
                    ...action,
                    architectureId,
                    parentId,
                    parentType: parentType === 'role' ? 'job-role' : 'job-level',
                    parentVersion,
                    tenantId,
                    timestamp,
                    userId,
                },
            });
        },
        [architectureId, parentId, parentType, parentVersion, tenantId, timestamp, trackEvent, userId],
    );
};
